<template>
  <div class="overflow-hidden header-context" ref="investor_evaluations">
    <base-header
      class="header header-context pb-8 pt-8 d-flex align-items-center"
    >
      <!-- Mask -->
      <span class="mask mask-style"></span>
      <!-- Header container -->
      <div class="align-items-center">
        <div class="row">
          <div class="col-12 mx-auto text-center">
            <h1 class="text-white highlight-text">Networking Secreto</h1>
            <p class="text-white mt-3 mb-5">
              Conecte-se com outros investidores
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container">
      <div
        class="d-flex justify-content-center align-items-center p-3 flex-wrap-reverse"
      >
        <div class="col-12 col-md-12 col-lg-6">
          <h1 class="mb-5">Match de Investidores</h1>

          <div class="row my-4">
            <i
              class="fa fa-lightbulb my-auto fa-2x mr-2 col-1 text-warning"
            ></i>
            <p class="d-inline col-10">
              Conheça outros investidores do mesmo fundo que você
            </p>
          </div>
          <div class="row my-4">
            <i
              class="fa fa-thumbs-up my-auto fa-2x mr-2 col-1 text-warning"
            ></i>
            <p class="d-inline col-10">
              Dê match nos perfis que possam te agregar ou que você pode
              contribuir
            </p>
          </div>
          <div class="row my-4">
            <i
              class="fa fa-smile-wink fa-2x my-auto mr-2 col-1 text-warning"
            ></i>
            <p class="d-inline col-10">
              Descubra seu match e agende uma reunião
            </p>
          </div>
        </div>
        <div
          class="col-12 col-sm-12 col-md-4 d-flex justify-content-center mt-5 mt-sm-0"
        >
          <img
            src="/img/pages/networking-icon.png"
            alt="Networking"
            style="min-width: 250px"
          />
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <base-button class="px-7" @click="goToApp()">Baixar App</base-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "networking-secreto",
  data() {
    return {};
  },

  methods: {
    goToApp() {
      window.open("https://www.google.com", "_blank");
      window.open("https://www.apple.com", "_blank");
    },
  },
};
</script>
<style scoped>
p {
  margin: 0;
}
.card {
  margin-top: 10px;
}
.card-profile-image img {
  width: 180px;
  height: 180px;
}

.header-context {
  background: transparent !important;
  background-color: none !important;
  border: none !important;
}
.highlight-text {
  font-size: 2.5rem;
  font-weight: 600;
}
.mask-style {
  background: linear-gradient(148.6deg, #f6705d -3.72%, #ff3d2c 112.16%);
  transform: rotate(357deg) scale(1.3);
  margin-top: -10%;
  filter: blur(0.5px);
}
.text-default-case {
  text-transform: none !important;
}
</style>
